import { c as f, q as g, g as u } from "./__packages__deps__queryProductByHandle-74f871fa.js";
import { l as m, g as p } from "./__packages__deps__web-463d2b45.js";
var i;
const [b, y] = m(
  ((i = window == null ? void 0 : window.currentProduct) == null ? void 0 : i.handle) || ""
), [c] = f(g, () => ({
  handle: b()
})), _ = p(() => {
  var a, s, o;
  const t = u((() => {
    var r, d, l;
    return (l = (d = (r = c()) == null ? void 0 : r.product) == null ? void 0 : d.metafields.find(
      (n) => (n == null ? void 0 : n.key) === "jp_attributes"
    )) == null ? void 0 : l.value;
  })(), "p_attributes");
  if (t.success)
    return (o = (s = (a = t.data) == null ? void 0 : a.find((r) => r.slug === "available-customizations")) == null ? void 0 : s.value) == null ? void 0 : o.split(",");
}), j = {
  currentProductAttributes: () => {
    var a;
    const e = c(), t = (a = e == null ? void 0 : e.product) == null ? void 0 : a.metafields.find(
      (s) => (s == null ? void 0 : s.key) === "jp_attributes"
    );
    return u(t == null ? void 0 : t.value, "p_attributes");
  },
  currentProductAssets: () => {
    var a;
    const e = c(), t = (a = e == null ? void 0 : e.product) == null ? void 0 : a.metafields.find(
      (s) => (s == null ? void 0 : s.key) === "jp_assets"
    );
    return u(t == null ? void 0 : t.value, "p_assets");
  }
};
export {
  _ as a,
  b as c,
  c as g,
  j as m,
  y as s
};
